import React from 'react';
import { ReportsView } from '../components/ReportsView/ReportsView';

export const ReportsPage = () => {
  return <ReportsView />;
};
